<template>
  <page
    :name="$t('Trasferimenti')"
    :state="[transfersState]"
    :empty="!transfers.length"
    :empty-text="$t('Nessun trasferimento in attesa di dati')"
  >
    <template #header>
      <pf-content component="p">
        {{ $t('In questa pagina è disponibile il form per l\'inserimento dei dati necessari alla richiesta di trasferimento di siti web, servizi di posta elettronica e domini.') }}<br />
        {{ $t('Il modulo è stato realizzato per semplificare, velocizzare e garantire la massima sicurezza durante le operazioni di migrazione, favorendo così una comunicazione chiara e sicura con il team tecnico di Artera in ogni fase.') }}<br />
        {{ $t('Dopo l\'invio del form, compilato correttamente in ogni sua parte, il supporto tecnico di Artera vi contatterà per le attività di verifica e per procedere con la migrazione.') }}
      </pf-content>
    </template>

    <pf-page-section no-body-wrapper>
      <pf-title h="2">{{ $t('Trasferimenti in corso') }}</pf-title>

      <transfers-list v-if="trasferByStatus.ongoing.length" :transfers="trasferByStatus.ongoing" @update="transfersState.update()" />

      <pf-empty-state v-else>
        <pf-empty-state-header :title="$t('Nessun trasferimento in corso')" heading-level="h4"/>
      </pf-empty-state>


      <template v-if="trasferByStatus.closed.length">
        <pf-title h="2">{{ $t('Trasferimenti conclusi') }}</pf-title>
        <pf-data-list compact>
          <pf-data-list-item v-for="tbd in trasferByStatus.closed" :key="tbd.dominio">
            <pf-data-list-cell>
              {{ tbd.dominio }}
            </pf-data-list-cell>
            <pf-data-list-cell v-for="t in tbd.transfers" :key="t.id" no-fill>
              {{ transferTitle(t) }}: <transfer-label :transfer="t" />
            </pf-data-list-cell>
          </pf-data-list-item>
        </pf-data-list>
      </template>
    </pf-page-section>
  </page>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { $t as _t } from '@/i18n';
import { TransferResource, type Transfers } from '@/resources';
import { asyncComputedList } from '@common/asyncComputed';
import TransfersList, { transferTitle } from '@/components/transfers-list.vue';
import TransferLabel from '@/components/transfer-label.vue';

const { state: transfersState, result: transfers } = asyncComputedList(() => new TransferResource().get());

const trasferByStatus = computed(() => {
  const ongoing: Transfers = [];
  const closed: Transfers = [];

  for (const t of transfers.value) {
    if (t.transfers.some(t => t.status !== 'canceled' && t.status !== 'completed')) {
      ongoing.push(t);
    } else {
      closed.push(t);
    }
  }

  return { ongoing, closed };
});
</script>
